import React ,{ useEffect } from "react";
import CanvasJSReact from '@canvasjs/react-charts';

// Load CanvasJS chart library
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const DoughnutChart = ({ dataPoints }) => {
  useEffect(() => {
    // Any initialization code can go here
  }, []);

  const options = {
    animationEnabled: true,
    title: {
      text: "註冊進度"
      
    },
    data: [{
      type: "doughnut",
      indexLabel: "{symbol} - {y}",
      yValueFormatString: "#,##0.0\"%\"",
      showInLegend: true,
      legendText: "{label} : {y}",
      dataPoints: dataPoints
    }]
  };

  return (
    <div>
      <CanvasJSChart options={options} />
    </div>
  );
};

export default DoughnutChart;
   